import Cookies from 'js-cookie'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import { setSecret } from '@/utils/CookieUtils'
import { partnerApi } from '@/stores/partnerApiClient'

const IS_RED_COOPERATION_PARTNER = 'isRedCooperationPartner'

export function isRedCooperationPartner(): boolean {
  const redCookie = Cookies.get(IS_RED_COOPERATION_PARTNER)
  if (redCookie === undefined) {
    // if cookie is unset, we assume red cooperation for security reasons
    return true
  }
  return redCookie === 'true'
}

export interface RedPartnerStatus {
  redCooperationPartner: boolean
}

export async function setRedPartnerStatusCookie(): Promise<boolean> {
  return new Promise<boolean>((resolve, _reject) => {
    getRedPartnerStatus()
      .then((status) => {
        setSecret(IS_RED_COOPERATION_PARTNER, String(status))
        const redCookie = Cookies.get(IS_RED_COOPERATION_PARTNER)
        if (redCookie === undefined) {
          resolve(false)
        }
        resolve(true)
      })
      .catch(() => {
        resolve(false)
      })
  })
}

async function getRedPartnerStatus(): Promise<boolean> {
  const partnerProxyId: string | null = getPartnerProxyId()
  if (!partnerProxyId) {
    throw new Error('No partner proxy id available!')
  }

  try {
    const response = await partnerApi().getRedCooperationStatusForPartner({
      partnerProxyId
    })
    return response.data?.redCooperationPartner ?? true
  } catch {
    return true
  }
}
